(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timed-product-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('timed-product-popup')) {
    class TimedProductPopup extends HTMLElement {
      connectedCallback() {
        if (this._initialized) return;
        this._initialized = true;

        this.dialog = this.querySelector('.tpp__dialog');
        this.targetsNode = this.querySelector('[data-popup-targets]');
        this.timer = null;
        this.previousFocus = null;
        this.previousBodyOverflow = '';
        this.isOpen = false;

        this.handleClick = this.handleClick.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.handleEditorEvent = this.handleEditorEvent.bind(this);

        this.addEventListener('click', this.handleClick);
        document.addEventListener('keydown', this.handleKeydown);

        if (window.Shopify && Shopify.designMode) {
          document.addEventListener('shopify:section:select', this.handleEditorEvent);
          document.addEventListener('shopify:block:select', this.handleEditorEvent);
          document.addEventListener('shopify:section:load', this.handleEditorEvent);
          return;
        }

        if (!this.shouldRun()) return;

        const delay = Math.max(0, Number(this.dataset.delay) || 0);
        this.timer = window.setTimeout(() => this.open(false), delay);
      }

      disconnectedCallback() {
        if (this.timer) window.clearTimeout(this.timer);
        this.removeEventListener('click', this.handleClick);
        document.removeEventListener('keydown', this.handleKeydown);
        document.removeEventListener('shopify:section:select', this.handleEditorEvent);
        document.removeEventListener('shopify:block:select', this.handleEditorEvent);
        document.removeEventListener('shopify:section:load', this.handleEditorEvent);

        if (this.isOpen && this.isModal()) {
          document.body.style.overflow = this.previousBodyOverflow;
        }
      }

      handleEditorEvent(event) {
        if (!event.detail || event.detail.sectionId !== this.dataset.sectionId) return;

        const blockId = event.detail.blockId;
        if (blockId) {
          const target = this.getTargets().find((item) => item.id === blockId);
          this.matchedHeading = target ? target.heading : '';
        } else {
          this.matchesTarget();
        }

        this.open(true);
      }

      handleClick(event) {
        if (event.target.closest('[data-popup-close]')) {
          event.preventDefault();
          this.close();
        }
      }

      handleKeydown(event) {
        if (!this.isOpen) return;

        if (event.key === 'Escape') {
          event.preventDefault();
          this.close();
          return;
        }

        if (!this.isModal() || event.key !== 'Tab' || !this.dialog) return;

        const focusable = Array.from(
          this.dialog.querySelectorAll(
            'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
          )
        ).filter((element) => !element.hasAttribute('hidden'));

        if (!focusable.length) {
          event.preventDefault();
          this.dialog.focus();
          return;
        }

        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }

      shouldRun() {
        if (this.dataset.enabled !== 'true') return false;
        if (!this.matchesDevice()) return false;
        if (!this.matchesTarget()) return false;
        if (this.isExcludedDestination()) return false;
        if (this.dataset.testMode !== 'true' && !this.frequencyAllows()) return false;
        return true;
      }

      matchesDevice() {
        const device = this.dataset.device || 'all';
        if (device === 'all') return true;

        const mobile = window.matchMedia('(max-width: 749px)').matches;
        return device === 'mobile' ? mobile : !mobile;
      }

      getTargets() {
        try {
          return JSON.parse(this.targetsNode?.textContent || '[]').filter((target) => target && target.url);
        } catch (error) {
          return [];
        }
      }

      matchesTarget() {
        const targets = this.getTargets();
        if (!targets.length) return false;

        const currentPath = this.normalizePath(window.location.href);
        const match = targets.find((target) => this.normalizePath(target.url) === currentPath);
        this.matchedHeading = match ? match.heading : '';
        return Boolean(match);
      }

      isExcludedDestination() {
        if (this.dataset.excludeDestination !== 'true') return false;
        if (!this.dataset.destination) return false;
        return this.normalizePath(this.dataset.destination) === this.normalizePath(window.location.href);
      }

      normalizePath(value) {
        const rawValue = String(value || '').trim();

        // Shopify's page picker can save internal links as shopify://blogs/…
        // rather than the storefront's /blogs/… URL. Treat both identically.
        if (rawValue.indexOf('shopify://') === 0) {
          const shopifyPath = rawValue.slice('shopify://'.length).replace(/^\/+/, '').replace(/\/+$/, '');
          return shopifyPath ? `/${shopifyPath}` : '/';
        }

        try {
          const url = new URL(rawValue, window.location.origin);
          const path = url.pathname.replace(/\/+$/, '');
          return path || '/';
        } catch (error) {
          return '';
        }
      }

      get storageKey() {
        const campaign = (this.dataset.campaignKey || 'default').trim() || 'default';
        return `timed-product-popup:${campaign}`;
      }

      frequencyAllows() {
        const frequency = this.dataset.frequency || '7';
        if (frequency === 'always') return true;

        if (frequency === 'session') {
          return !this.safeGet(window.sessionStorage, this.storageKey);
        }

        const days = Number(frequency);
        const lastSeen = Number(this.safeGet(window.localStorage, this.storageKey));
        if (!lastSeen || Number.isNaN(lastSeen)) return true;

        return Date.now() - lastSeen >= days * 86400000;
      }

      markSeen() {
        const frequency = this.dataset.frequency || '7';
        if (frequency === 'always') return;

        if (frequency === 'session') {
          this.safeSet(window.sessionStorage, this.storageKey, '1');
          return;
        }

        this.safeSet(window.localStorage, this.storageKey, String(Date.now()));
      }

      safeGet(storage, key) {
        try {
          return storage.getItem(key);
        } catch (error) {
          return null;
        }
      }

      safeSet(storage, key, value) {
        try {
          storage.setItem(key, value);
        } catch (error) {
          // Some privacy modes disable browser storage. The popup can still display.
        }
      }

      isModal() {
        return this.dataset.layout === 'modal';
      }

      applyHeading() {
        const headingEl = this.querySelector('.tpp__heading');
        if (!headingEl) return;

        if (this._defaultHeadingText === undefined) {
          this._defaultHeadingText = headingEl.textContent;
        }

        headingEl.textContent = this.matchedHeading ? this.matchedHeading.trim() : this._defaultHeadingText;
      }

      open(editorPreview = false) {
        if (this.isOpen) return;
        if (!editorPreview && !this.shouldRun()) return;

        this.isOpen = true;
        this.previousFocus = document.activeElement;
        this.applyHeading();

        if (this.isModal()) {
          this.previousBodyOverflow = document.body.style.overflow;
          document.body.style.overflow = 'hidden';
        }

        this.hidden = false;
        this.setAttribute('aria-hidden', 'false');

        if (!editorPreview && this.dataset.testMode !== 'true') this.markSeen();

        window.requestAnimationFrame(() => {
          const closeButton = this.querySelector('.tpp__close');
          (closeButton || this.dialog)?.focus();
        });
      }

      close() {
        if (!this.isOpen) return;

        this.isOpen = false;
        this.hidden = true;
        this.setAttribute('aria-hidden', 'true');

        if (this.isModal()) {
          document.body.style.overflow = this.previousBodyOverflow;
        }

        if (this.previousFocus && typeof this.previousFocus.focus === 'function') {
          this.previousFocus.focus({ preventScroll: true });
        }
      }
    }

    customElements.define('timed-product-popup', TimedProductPopup);
  }

  } catch(e) { console.error(e); }
})();
})();
